/**
 * Products
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import Handlebars from 'handlebars';

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.products',

	state: {
		filters: {},
	},

	events: {
		'click button.filter': 'onFilterClick',
		'click .products__bottom-area__products__btn-show-more button': 'onShowMoreClick',
		'click .products__card__details button, .products__card__details-desktop button': 'onViewDetailsClick',
	},

	onRender() {
		this.state.BtnShowMoreContainer = this.el.querySelector('.products__bottom-area__products__btn-show-more');
		this.state.BtnShowMoreContainer.classList.add('loading');

		this.api.get('/api/products', this.state.filters, this.renderProductCard.bind(this), true);
	},

	onFilterClick(e) {
		const filter = e.delegateTarget;
		this.toggleFilter(filter);
	},

	toggleFilter(filter) {
		filter.classList.toggle('selected');
		this.setFilters();
	},

	setFilters() {
		this.state.BtnShowMoreContainer.classList.add('loading');
		const filtersCategory = this.el.querySelectorAll('.js-filter-category .filter.selected');
		const filtersType = this.el.querySelectorAll('.js-filter-type .filter.selected');

		const selectedFilters = {
			category: [],
			type: [],
		};

		filtersCategory.forEach((item) => {
			selectedFilters.category.push(item.dataset.value.toLowerCase());
		});

		filtersType.forEach((item) => {
			selectedFilters.type.push(item.dataset.value.toLowerCase());
		});

		this.state.filters = selectedFilters;

		this.api.get('/api/products', this.state.filters, this.renderProductCard.bind(this), true);
	},

	onShowMoreClick() {
		this.state.BtnShowMoreContainer.classList.add('loading');
		this.api.get('/api/products', this.state.filters, this.renderProductCard.bind(this), false);
	},

	onViewDetailsClick(e) {
		const productId = {
			id: e.delegateTarget.dataset.productId,
		};
		this.api.get('/api/products', productId, this.openDetailsModal.bind(this), false);
	},

	openDetailsModal(productData) {
		const productDetails = JSON.parse(productData.response);

		App.modal.create({
			type: 'generic-productdetails-modal',
			model: {
				productDetails,
			},
		});
	},

	renderProductCard(data, emptyContainer) {
		const response = JSON.parse(data.response);
		const { isLastItems, items } = response;
		const source = document.getElementById('products__card__template').innerHTML;
		const template = Handlebars.compile(source);
		const showMoreBtn = this.el.querySelector('.products__bottom-area__products__btn-show-more button');

		if (emptyContainer) {
			this.el.querySelector('.products__bottom-area__products').innerHTML = '';
		}

		items.forEach((product) => {
			const html = template(product);
			this.el.querySelector('.products__bottom-area__products').innerHTML += html;
		});

		const cards = this.el.querySelectorAll('.products__card');

		if (cards.length <= 2) {
			if (cards[0]) cards[0].classList.add('card-big');
			if (cards[1]) cards[1].classList.add('card-big');
		}

		this.state.BtnShowMoreContainer.classList.remove('loading');
		if (isLastItems) {
			showMoreBtn.disabled = true;
		} else {
			showMoreBtn.disabled = false;
		}
	},

	api: {
		get(baseUrl, params, callback, emptyContainer) {
			const queryString = Object.keys(params).map((key) => {
				return `${key}=${params[key]}`;
			}).join('&');

			const url = encodeURI(`${baseUrl}?${queryString}`);

			const xhttp = new XMLHttpRequest();
			xhttp.onreadystatechange = function onreadystatechange() {
				if (this.readyState === 4 && this.status === 200) {
					callback(this, emptyContainer);
				}
			};

			xhttp.open('GET', url, true);
			xhttp.send();
		},
	},
});

export default View;
